export default class Validate {
  static validarCampo(name, value, opts) {
    switch (name) {
      // case 'numeroDocumentoCobro':
      //     return Validate.validarNumero(value);
      // case 'nombreEmpresa':
      //     return Validate.validarAlfanumerico(value);
      // case 'direccion':
      //     return Validate.validarAlfanumerico(value);
      // case 'marca':
      //     return Validate.validarAlfanumerico(value);
      // case 'modelo':
      //     return Validate.validarAlfanumerico(value);
      // case 'dscSiniestro':
      //     return Validate.validarComentarios(value);
      // case 'nombreCompleto':
      //     return Validate.validarSoloTexto(value);
      // case 'tipo':
      //     return Validate.validarSoloTexto(value);
      // case 'telefono':
      //     return Validate.validarTelefono(value);
      // case 'cuenta':
      //     return Validate.validarNumero(value);
      // case 'correo':
      //     return Validate.validarEmail(value);
      // case 'cantidad':
      //     return Validate.validarNumeroPositivos(value);
      // case 'pares':
      //     return Validate.validarNumeroPositivos(value);
      // case 'costo':
      //     return Validate.validarNumeroDecimal(value);
      // case 'ideDireccion':
      // case 'ideSeguro':
      // case 'ideCobertura':
      // case 'ideTipoActivo':
      // case 'rdoCuenta':
      // case 'ideBanco':
      // case 'rdoSiniestro':
      // case 'v_fecha':
      // case 'activo':
      // case 'modelo_serie':
      //     return Validate.validarNull(value.trim());
      case "v_codigoProducto":
        return Validate.validarNumero(value);
      default:
        return true;
    }
  }

  static validarNull(value) {
    if (
      value === undefined ||
      value === null ||
      value.length === 0 ||
      value === ""
    ) {
      return false;
    }
    return true;
  }

  static validarNumero(value) {
    let regExp = /^[0-9]+$/;

    return Validate.validarNull(value) ? regExp.test(value) : false;
  }
  static validarPorcentaje(value) {

    return Validate.validarNull(value) ? (value<=100) : false;
  }

  static validarTelefono(value) {
    let regExp = /^[0-9]+$/;

    return Validate.validarNull(value)
      ? regExp.test(value) && value.length > 6 && value.length < 10
      : false;
  }

  static validarUsername(name, value, minlength) {
    let resp = {};
    let valnumber = Validate.validarNumero(value);
    let valrangomin = Validate.validarLongitudMin(value, minlength);

    if (valnumber) {
      if (valrangomin) {
        resp.validate = true;
        resp.msj = "";
      } else {
        resp.validate = false;
        resp.msj =
          "El campo " +
          name +
          " debe contener por lo menos " +
          minlength +
          " caracteres";
      }
    } else {
      resp.validate = false;
      resp.msj = "El campo " + name + " solo permite números";
    }

    return resp;
  }

  static validarPass(name, value, minlength) {
    let resp = {};
    let valrangomin = Validate.validarLongitudMin(value, minlength);

    if (valrangomin) {
      resp.validate = true;
      resp.msj = "";
    } else {
      resp.validate = false;
      resp.msj =
        "El campo " +
        name +
        " debe contener por lo menos " +
        minlength +
        " caracteres";
    }

    return resp;
  }

  static validarLongitud(value, minlength, maxlength) {
    if (value === undefined || value === null || value.length === 0) {
      return false;
    } else {
      if (value.length >= minlength && value.length <= maxlength) {
        return true;
      } else {
        return false;
      }
    }
  }

  static validarLongitudMin(value, minlength) {
    if (value === undefined || value === null || value.length === 0) {
      return false;
    } else {
      if (value.length >= minlength) {
        return true;
      } else {
        return false;
      }
    }
  }

  static validarLongitudMax(value, maxlength) {
    if (value === undefined || value === null || value.length === 0) {
      return false;
    } else {
      if (value.length <= maxlength) {
        return true;
      } else {
        return false;
      }
    }
  }

  static validarComentarios(value) {
    let regExp = /^[+]?([0-9]+(?:[0-9]*)?|[0-9]+)$/;
    return Validate.validarNull(value) ? !regExp.test(value) : false;
  }

  static validarNumeroPositivos(value) {
    let regExp = /^[0-9]*$/;

    return Validate.validarNull(value)
      ? regExp.test(value) && value > 0
      : false;
  }

  static validarNumeroDecimal(value) {
    let regExp = /^[0-9]*(.[0-9]+)?$/;

    return Validate.validarNull(value)
      ? regExp.test(value) && value > 0
      : false;
  }

  static validarEmail(value) {
    let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return Validate.validarNull(value) ? regExp.test(value) : false;
  }
  static validarWeb(value) {
    let regExp = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/;

    return Validate.validarNull(value) ? regExp.test(value.toLowerCase()) : false;
  }
  

  static validarSoloTexto(value) {
    let regExp = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/i;

    return Validate.validarNull(value) ? regExp.test(value) : false;
  }

  static validarAlfanumerico(value) {
    let regExp = /^[0-9A-Za-záÁéÉíÍóÓúÚ&-\s]*$/i;

    return Validate.validarNull(value) ? regExp.test(value) : false;
  }

  static validarDocumento(idpTipoDocumento, numeroDocumento) {
    if(!idpTipoDocumento)
       return false;
    switch (idpTipoDocumento) {
      case 'RUC': //RUC
        if (
          Validate.validarNumero(numeroDocumento) &&
          numeroDocumento.length === 11
        ) {
          return true;
        } else {
          return false;
        }
      case 'DNI': //DNI
        if (
          Validate.validarNumero(numeroDocumento) &&
          numeroDocumento.length === 8
        ) {
          return true;
        } else {
          return false;
        }
      case 'CE':
      case 'PSP': 
        if (
          Validate.validarAlfanumerico(numeroDocumento) &&
          numeroDocumento.length <= 12
        ) {
          return true;
        } else {
          return false;
        }      
      default:
        if (
          Validate.validarAlfanumerico(numeroDocumento) &&
          numeroDocumento.length <= 15
        ) {
          return true;
        } else {
          return false;
        }
    }
  }
  static validarNumeroCuenta(idpBanco, idpTipoCuenta, numCuenta) {
    let mensajeCuenta = 'El n° de cuenta debe tener ';
    if(!idpBanco || !idpTipoCuenta)
       return '';
    switch (`${idpBanco}-${idpTipoCuenta}`) {
      case '002-A': //CREDITO ahorro
        if (
          Validate.validarNumero(numCuenta) &&
          numCuenta.length === 14
        ) {
          return '';
        } else {
          return mensajeCuenta+'14 digitos';
        }
      case '002-C': //CREDITO ahorro
        if (
          Validate.validarNumero(numCuenta) &&
          numCuenta.length === 13
        ) {
          return '';
        } else {
          return mensajeCuenta+'13 digitos';
        }
      case '005-A': //BBVA
        if (
          Validate.validarNumero(numCuenta) &&
          numCuenta.length === 18
        ) {
          return '';
        } else {
          return mensajeCuenta+'18 digitos';
        }
      case '005-C': //BBVA
        if (
          Validate.validarNumero(numCuenta) &&
          numCuenta.length === 18
        ) {
          return '';
        } else {
          return mensajeCuenta+'18 digitos';
        }
      case '007-A':  //INTERBANK
        if (
          Validate.validarAlfanumerico(numCuenta) &&
          numCuenta.length == 12
        ) {
          return '';
        } else {
          return mensajeCuenta+'12 digitos';
        }
      case '007-C':  //INTERBANK
        if (
          Validate.validarAlfanumerico(numCuenta) &&
          numCuenta.length == 12
        ) {
          return '';
        } else {
          return mensajeCuenta+'12 digitos';
        }
      case '009-A':  //SCOTIABANK
        if (
          Validate.validarAlfanumerico(numCuenta) &&
          numCuenta.length == 10
        ) {
          return '';
        } else {
          return mensajeCuenta+'10 digitos';
        }
      case '009-C':  //SCOTIABANK
        if (
          Validate.validarAlfanumerico(numCuenta) &&
          numCuenta.length == 10
        ) {
          return '';
        } else {
          return mensajeCuenta+'10 digitos';
        } 
      default:
        if (
          Validate.validarAlfanumerico(numCuenta) &&
          numCuenta.length <= 18
        ) {
          return '';
        } else {
          return mensajeCuenta+'menos de 18 digitos';
        }
    }
  }

  static validarFormState(state, tipo) {
    var result = true;
    var arrayKeys = Object.keys(state).filter((key) => {
      return key.indexOf("v_", 0) !== -1;
    });

    arrayKeys.forEach((key) => {
      if ("formulario" === tipo) {
        result = result && state[key];
      } else if ("filtro" === tipo) {
        result = result || state[key];
      } else {
        result = result && state[key];
      }
    });
    return result;
  }

  static convertirMayusculas(value) {
    let upperValue = value.toUpperCase();
    return upperValue;
  }

  static convertirMinusculas(value) {
    let lowerValue = value.toLowerCase();
    return lowerValue;
  }

  static soloNumeros(event) {
    let { value } = event.target;
    let regExp = /^[0-9]+$/;

    return regExp.test(value);
  }

  static isMobile() {
    return {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          this.Android() ||
          this.BlackBerry() ||
          this.iOS() ||
          this.Opera() ||
          this.Windows()
        );
      },
    };
  }

  static getLocalStorageValueForRegex(regex) {
    var resp;
    Object.keys(localStorage).forEach(function (key) {
      if (regex.test(key)) {
        resp = localStorage.getItem(key);
      }
    });
    return resp;
  }

  static extraerAtributos(jsonPlantilla, jsonValor, jsonPlantillaArray) {
    var resp={};
    for (var name in jsonPlantilla) {
      if (jsonPlantilla.hasOwnProperty(name) ){
        resp[name] = jsonValor[name] || "";
        if(jsonValor[name] instanceof Array && jsonPlantillaArray){
          resp[name]=[];
          for(let elem of jsonValor[name]){
            let jsonTemp={};
            for (var name2 in jsonPlantillaArray) {
              if (jsonPlantillaArray.hasOwnProperty(name2) ){
                jsonTemp[name2]=elem[name2] || "";
              }
            }
            resp[name].push(jsonTemp);
          }
        }
      }
    }
    return resp;
  }
  static limpiarArregloIdProveedor(arreglo) {
    var resp={arr:[], delete:[]};
    for(var i=0;i<arreglo.length; i++ ) {
      var elem = arreglo[i];
      let indVacio=true;
      for (var name in elem) {
        if (elem.hasOwnProperty(name) ){
          if(elem[name] && name!='idProveedor' && name!='idMedioContacto' && name!='idpTipoContacto' && name!='idFormaPago'){
            indVacio=false;
            break;
          }
        }
      }
      if(indVacio && elem && Object.keys(elem).length>0){
        if(elem.idMedioContacto)
          resp.delete.push(elem.idMedioContacto);
        if(elem.idFormaPago)
          resp.delete.push(elem.idFormaPago);
        arreglo.splice(i,1);
        i--;        
      }
    }
    resp.arr=arreglo;
    return resp;
  }
  static limpiarObjeto(json){
    for (var name in json) {
      if (json.hasOwnProperty(name) ){
        if(!json[name]){
          delete json[name];
        }
      }
    }
    return json;
  }
}
